import { createContext } from 'react';
import { MyTrainingsViewContextProps } from "context/myTrainings/MyTrainingsViewContextProps";
import { initialUserWorkspaceState } from 'context/intitialUserWorkspaceState';

const initialState: MyTrainingsViewContextProps = {
    user: initialUserWorkspaceState,
    trainingStatistics: {
        allLessonsProgress: 0,
        lessonsCount: 0,
        lessons: [],
        allProgresses: [],
        actualProgresses: [],
        organizationParticipantsCount: 0,
        placeInOrganizationRanking: 0,
        sumOfMaxPoints: 0,
        sumOfPointsScored: 0,
    },
    getStatisticsPending: false,
    isStatisticOfLoggedUser: false,
}

export const MyTrainingsViewContext = createContext<MyTrainingsViewContextProps>(initialState);